export const SET_DIALOG_OPEN = 'SET_DIALOG_OPEN' as const;
export const SET_DIALOG_CLOSED = 'SET_DIALOG_CLOSED' as const;
export const SET_REQUESTED_FOCUS_ID = 'SET_REQUESTED_FOCUS_ID' as const;

export const setDialogOpen = () => ({ type: SET_DIALOG_OPEN });
export const setDialogClosed = () => ({ type: SET_DIALOG_CLOSED });
export const setRequestedFocusId = (focusId: string | null) => ({
  type: SET_REQUESTED_FOCUS_ID,
  payload: focusId,
});
